import { createSelector } from 'reselect';
import get from 'lodash/get';

export const removeParticipantSelector = state =>
  state.board.reqRemoveParticipant;

export const removedMemberIdSelector = createSelector(
  removeParticipantSelector,
  request => get(request, 'removedMemberId', null),
);



// WEBPACK FOOTER //
// ./src/redux/board/selectors/removeParticipant.js